import makeStyles from '@material-ui/core/styles/makeStyles';
export var useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
    },
    balanceCardWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        columnGap: '10px',
    },
    currentBalanceAmount: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '35px',
        color: '#FFFFFF',
        '& svg': {
            marginLeft: '5px',
        },
        '& div': {
            marginLeft: '5px',
            fontSize: '35px',
        },
    },
    currentBalanceTitle: {
        marginTop: '16px',
        fontSize: '14px',
        color: '#FFFFFF',
    },
    button: {
        fontSize: '16px',
    },
}, { name: 'ShopBalance' });
